import React from 'react';
import { Icon } from './Icon';

const BoxIcon = ({ size }: Props) => {
  return (
    <Icon type="box" color="bg-label-secondary" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { BoxIcon };